import React from 'react'
import PropTypes from 'prop-types'
import SEOStructuredData from '../../../components/seo-structured-data'

/**
 * PDCHomeSEO is a functional component responsible for rendering SEO structured data
 * for the home page of the Page Designer application.
 *
 * @param {Object} props - The properties object.
 * @param {Object} props.structuredData - The structured data object that contains
 *                                        the SEO information to be rendered.
 *
 * @returns {JSX.Element} A JSX element that represents the SEO structured data
 *                        for the home page.
 */
export const PDCHomeSEO = ({structuredData}) => {
    return <SEOStructuredData type={'home'} data={structuredData}></SEOStructuredData>
}

PDCHomeSEO.propTypes = {
    structuredData: PropTypes.string
}
